import React, {useMemo} from 'react';
import Email from '@/components/Email/index';
import {Avatar} from 'antd';
import {CheckCircleOutlined, MinusCircleOutlined} from '@ant-design/icons';
import classNames from 'classnames';
import {useAHAB} from '@/contexts/AHABProvider';
import {find} from 'lodash';

/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * */
export const renderEmail = (email, item) => <Email item={item}>{email}</Email>;


/**
 * This is not a component,
 * it is a function to render the Avatar component in a table cell
 * */
export const renderAvatar = (avatar) => <Avatar src={avatar}/>;

/**
 * This is not a component,
 * it is a function to render the Squared Avatar component in a table cell
 * */
export const renderSquareAvatar = (avatar) => <Avatar shape="square" src={avatar}/>;

export const renderBool = value => (
  <span className={classNames({'text-primary': value}, 'text-xl leading-none')}>
    {value ? <CheckCircleOutlined/> : <MinusCircleOutlined/>}
  </span>
);

export const RenderMunicipality = value => {
  const { isLoadingMunicipalities, municipalities } = useAHAB();
  const currentMunicipality = useMemo(() => {
    if (!isLoadingMunicipalities) {
      return find(municipalities, { 'pk': Number(value?.contractInfo?.residential?.metadata?.address?.municipality) })?.municipio;
    }
  }, [isLoadingMunicipalities, municipalities, value]);
  return <span>{currentMunicipality}</span>;
};

export const RenderBigClientMunicipality = value => {
  const { isLoadingMunicipalities, municipalities } = useAHAB();
  const currentMunicipality = useMemo(() => {
    if (!isLoadingMunicipalities) {
      return find(municipalities, { 'pk': Number(value?.contractInfo?.bigClient?.metadata?.constitutedInfo?.legalAddress.municipality) })?.municipio;
    }
  }, [isLoadingMunicipalities, municipalities, value]);
  return <span>{currentMunicipality}</span>;
};
